import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (zone) =>
    present(
      repository
        .getZone(zone)
        .catch((error) => Promise.reject({ zone, error })),
    );
}

export type { Interactor };

export { createInteractor };
